function formatSubscriptionLabel() {
  const subscriptionLabels = document.querySelectorAll('.subscription-radio .discount-label');

  subscriptionLabels.forEach((label) => {
    // Skip if already formatted
    if (label.querySelector('.rc-label--highlight')) return;

    // Get original text like "Subscribe & save 10%"
    const originalText = label.textContent;

    // Extract the percentage using regex
    const percentMatch = originalText.match(/\d+%/);
    const discountText = percentMatch ? percentMatch[0] : '';

    // Create wrapper span for "Subscribe"
    const subscribeSpan = document.createElement('span');
    subscribeSpan.textContent = 'Subscribe';

    // Create wrapper span for "Save X%" with badge styling
    const saveSpan = document.createElement('span');
    saveSpan.textContent = `Save ${discountText}`;
    saveSpan.classList.add('rc-label--highlight');

    // Clear original text and append new formatted spans
    label.textContent = '';
    label.appendChild(subscribeSpan);
    label.appendChild(saveSpan);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  formatSubscriptionLabel();

  const observer = new MutationObserver((mutations) => {
    formatSubscriptionLabel();
  });

  const widgetContainer = document.querySelector('.recharge-subscription-widget');
  if (widgetContainer) {
    observer.observe(widgetContainer, {
      childList: true,
      subtree: true,
    });
  }
});
